import React, { useEffect, useRef, useState } from 'react'
import Layout from '../common/Layout'
import ApiHelper from '../../helperFunction/ApiHelper'
import API_ENDPOINTS from '../../helperFunction/Constant'
import { useNavigate, useParams } from 'react-router-dom'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ConfirmDialog } from 'primereact/confirmdialog'
import { Toast } from 'primereact/toast'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'
import { TabPanel, TabView } from 'primereact/tabview'
import CustomerDetails from './CustomerDetails'
import CustomerQuizHistory from './CustomerQuizHistory'
import OrdersModel from '../OrdersModel/OrdersModel'

const CustomerOrders = () => {

    const [activeIndex, setActiveIndex] = useState(0);

    const [visible, setVisible] = useState(false)

    const [orderModelData, setOrderModelData] = useState(null)
    

    const { id } = useParams()

    const toast = useRef(null)
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const [customers, setCustomers] = useState([])
    const [customerDetails, setCustomerDetails] = useState([])
    const [quizData, setQuizData] = useState([])
    const navigate = useNavigate()

    useEffect(() => {
        getCustomers()
    }, [])

    const getCustomers = () => {
        ApiHelper.get(`${API_ENDPOINTS.CUSTOMER_ORDERS}/${id}`).then((res) => {
            console.log('res: ', res);
            if (res.status === 200) {
                setCustomers(res?.data?.data)
                setCustomerDetails(res?.data?.customers)
                setQuizData(res?.data?.quizHistory)
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const serialNoTemplate = (rowData, options) => { return options.rowIndex + 1; };

    const imageBodyTemplate = (rowData) => {
        const courseCount = rowData?.courses?.length || 0;
        const firstCourse = rowData?.courses?.[0];
        return (
            <>
                {firstCourse?.courseImage ? (
                    <div style={{ display: "flex", alignItems: "center", gap: "12px", minWidth: 0, cursor: 'pointer' }} title={firstCourse?.courseName} onClick={() => { setOrderModelData(rowData); setVisible(true); }}>
                        <div style={{ flexShrink: 0, width: '60px', height: '40px' }} >
                            {firstCourse?.courseImage && firstCourse?.courseImage !== 'null' ? (
                                <img
                                    src={`${process.env.REACT_APP_BASE_URL}/${firstCourse?.courseImage}`}
                                    alt=""
                                    style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '4px' }}
                                    onError={(e) => {
                                        e.target.src = "/img/placeholder-image.jpg"
                                    }}
                                />
                            ) : (
                                <div style={{ width: '100%', height: '100%', background: '#e9ecef', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <i className="bi bi-journal-text text-secondary"></i>
                                </div>
                            )}
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", minWidth: 0, flex: 1 }}>
                            <span className='show-more-text' style={{fontWeight: '600', fontSize: '0.9rem'}} > {firstCourse?.courseName || 'Unknown Course'} </span>
                            <span style={{ fontSize: '0.8rem', color: '#6b7280', marginTop: '2px' }}>
                                {courseCount} {courseCount === 1 ? 'Course' : 'Courses'}
                            </span>
                        </div>
                    </div>
                ) : null}
            </>
        );
    };

    const statusBodyTemplate = (rowData) => {
        return (
            <span className={`badge ${rowData.paymentStatus === 'success' && 'bg-success' || rowData.paymentStatus === 'failed' && 'bg-danger' || rowData.paymentStatus === 'pending' && 'bg-info'}`}>
                {rowData.paymentStatus}
            </span>
        );
    };
    
    const renderHeader = () => {
        return (
            <div className="flex justify-content-end">
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={(e) => setGlobalFilterValue(e.target.value)} placeholder="Search" />
                </IconField>
            </div>
        );
    };

    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <Layout>
                <div class="content-wrapper">
                    <div class="container-xxl flex-grow-1 container-p-y">
                        <div class="d-flex justify-content-between align-items-center py-3">
                            <h4 class="fw-bold py-3 mb-2">
                                <span class="d-flex text-muted fw-light"> 
                                    <p class="breadcrumb-item pageHeader active me-2 mb-0" aria-current="page" onClick={() => navigate('/customers')}> Customers </p> / <b className='mx-2'> Details </b>
                                </span>
                            </h4>
                            {/* <Link class="btn btn-primary" to={'/customers/add'} >Add New Customer</Link> */}
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card mb-4">
                                    <div class="card-body">
                                    <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                                        <TabPanel header="Basic Information">
                                            <CustomerDetails data={customerDetails} />
                                        </TabPanel>
                                        <TabPanel header="Orders">
                                            <DataTable globalFilter={globalFilterValue} header={renderHeader} paginator rows={50} rowsPerPageOptions={[50, 100, 150, 200]} showGridlines size="small" value={customers} tableStyle={{ minWidth: '50rem' }} >
                                                <Column sortable header='S.NO' body={serialNoTemplate} />
                                                <Column sortable header='Course Name' body={imageBodyTemplate} field='courseName' />
                                                <Column sortable header='Order Number' field='orderNumber' />
                                                <Column sortable header='Total' field='grandTotal' />
                                                <Column sortable header='Payment Method' field='paymentMethod' />
                                                <Column sortable header='Failed Reason' field='failureReason' />
                                                <Column sortable header='Status' body={statusBodyTemplate} />
                                                <Column sortable header='Order Date' field='createdAt' body={(rowData) => {
                                                    const date = new Date(rowData.createdAt);
                                                    return date.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: true, });
                                                }} />
                                            </DataTable>
                                        </TabPanel>
                                        <TabPanel header="Quiz History">
                                            <CustomerQuizHistory data={quizData} user={'quiz'} />
                                        </TabPanel>
                                    </TabView>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
            <OrdersModel data={orderModelData || null} visible={visible} setVisible={setVisible} />
        </>
    )
}

export default CustomerOrders
